import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ContractInterface } from "../../Entity/Entities/Contract/ContractInterface";
import Translator from "../../Translation/Translator";
import Http from "../../Http/Http";

export default function* contractDelete(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_CONTRACT_DELETE_REQUEST
    });

    yield call(Http.delete, `contract/${action.payload?.contract.id}`);

    const contract: ContractInterface = action.payload?.contract.reinitialize({
      removed: true
    });

    yield put({
      type: Constants.GLOBAL_CONTRACT_DELETE_SUCCESS,
      payload: {
        contract: contract
      }
    });

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-contract-removed-successfully"),
        type: "success"
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this);
    }

  } catch (err) {

    yield ErrorHandlerSequence(err, action);

  }
}

export function* watchContractDelete() {
  yield takeEvery(Constants.GLOBAL_CONTRACT_DELETE_START, contractDelete);
}
